module.exports = __webpack_public_path__ + "media/escudos/logo_gr_cusco-834129de.png";